import { render } from "./CabinetSidebar.vue?vue&type=template&id=5fb957e8&lang=pug"
import script from "./CabinetSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./CabinetSidebar.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__